import salvarApostas from "./salvar-apostas";
import detalheApostaPayload from "./detalhe-aposta-payload";
import detalheApostaRetorno from "./detalhe-aposta-retorno";
import listaDeApostasPayload from "./lista-de-apostas-payload";
import listaDeApostasRetorno from "./lista-de-apostas-retorno";
import newSession from "./new-session"

let mockedApi = {
    newSession: {},
    salvarAposta: {},
    detalheApostaPayload: {},
    detalheApostaRetorno: {},
    listaDeApostasPayload: {},
    listaDeApostasRetorno: {}
}

mockedApi.salvarAposta = salvarApostas;

mockedApi.detalheApostaPayload[detalheApostaPayload.strTicket]
    = detalheApostaPayload;

mockedApi.detalheApostaRetorno[detalheApostaPayload.strTicket]
    = detalheApostaRetorno;

mockedApi.listaDeApostasPayload = listaDeApostasPayload;
mockedApi.listaDeApostasRetorno = listaDeApostasRetorno;

mockedApi.newSession = newSession;

export default mockedApi;


// WEBPACK FOOTER //
// ./src/mocking/mockStore.js